import React from "react"
import { Container, Message } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons"

const ErrorNotice = ({ error_message }) => {
  return (
    <Container>
      <div>
        <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: "16px" }} />
      </div>
      <Message>{error_message}</Message>
    </Container>
  )
}

export default ErrorNotice
